var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01367 8.00002C5.01367 7.11637 5.73002 6.40002 6.61367 6.40002H25.8137C26.6973 6.40002 27.4137 7.11637 27.4137 8.00002C27.4137 8.88368 26.6973 9.60002 25.8137 9.60002H6.61367C5.73002 9.60002 5.01367 8.88368 5.01367 8.00002Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01367 16C5.01367 15.1164 5.73002 14.4 6.61367 14.4H25.8137C26.6973 14.4 27.4137 15.1164 27.4137 16C27.4137 16.8837 26.6973 17.6 25.8137 17.6H6.61367C5.73002 17.6 5.01367 16.8837 5.01367 16Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01367 24C5.01367 23.1164 5.73002 22.4 6.61367 22.4H16.2137C17.0973 22.4 17.8137 23.1164 17.8137 24C17.8137 24.8837 17.0973 25.6 16.2137 25.6H6.61367C5.73002 25.6 5.01367 24.8837 5.01367 24Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.d88bdc73b46e7b247835ecc835209166.svg";
export { ForwardRef as ReactComponent };